import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);
new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
